import { quill } from "./modules/editor.js";
import { submitGuestPost } from "./modules/ajax.js";
import { setupSiteDropdown } from "./modules/siteDropdown.js";

/**
 * guestPost.js v1.0.0
 */
(function(window) {
    "use strict";

    function extend(a, b) {
        for (const key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    function guestPost(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    }

    guestPost.prototype._init = function() {
        // current question
        this.current = 0;

        // questions
        this.questions = [].slice.call(this.el.querySelectorAll("ol.questions > li"));
        // total questions
        this.questionsCount = this.questions.length;
        // show first question
        this.questions[0].classList.add("current");

        // next question control
        this.ctrlNext = this.el.querySelector("button.next");

        // previous question control
        this.ctrlPrevious = this.el.querySelector("button.previous");

        // progress bar
        this.progress = this.el.querySelector("div.progress");

        // question number status
        this.questionStatus = this.el.querySelector("span.number");
        // current question placeholder
        this.currentNum = this.questionStatus.querySelector("span.number-current");
        this.currentNum.innerHTML = Number(this.current + 1);
        // total questions placeholder
        this.totalQuestionNum = this.questionStatus.querySelector("span.number-total");
        this.totalQuestionNum.innerHTML = this.questionsCount;

        // init events
        this._initEvents();
    };

    guestPost.prototype._initEvents = function() {
        const self = this;
        // first input
        const firstElInput = this.questions[this.current].querySelector(".input");

        // focus
        const onFocusStartFn = function() {
            self.ctrlNext.classList.add("show");
        };

        // show the next question control first time the input gets focused
        if (firstElInput) {
            firstElInput.addEventListener("focus", onFocusStartFn);

            // focus the first input on the first page
            firstElInput.focus();
        }

        // show next question
        this.ctrlNext.addEventListener("click", function(ev) {
            ev.preventDefault();
            self._nextQuestion();
        });

        this.ctrlPrevious.addEventListener("click", function(ev) {
            ev.preventDefault();
            self._previousQuestion();
        });

        // update progress bar
        this._progress();

        // pressing enter will jump to next question
        document.addEventListener("keydown", function(ev) {
            const keyCode = ev.keyCode || ev.which;

            if (document.activeElement.classList.contains("js-bio") || document.activeElement.classList.contains("js-feedback")) {
                // Don't interfere with the user while they edit a bio
                return;
            }

            // enter or right arrow key
            if ((keyCode === 13 || keyCode === 39) && !quill.hasFocus()) {
                ev.preventDefault();
                self._nextQuestion();
            }
            // left arrow key
            if (keyCode === 37 && !quill.hasFocus()) {
                ev.preventDefault();
                self._previousQuestion();
            }
        });

        // Display the bio counter
        const countElem = document.querySelector(".bio-count");

        document.addEventListener("keyup", function() {
            if (document.activeElement.classList.contains("js-bio")) {
                // Don't interfere with the user while they edit a bio
                self._bioCounterDisplay(countElem);
            }
        });

        document.addEventListener("paste", function() {
            if (document.activeElement.classList.contains("js-bio")) {
                // Don't interfere with the user while they edit a bio
                self._bioCounterDisplay(countElem);
            }
        });
    };

    guestPost.prototype._previousQuestion = function() {
        // clear any previous error messages
        this._clearError();

        // current question
        const currentQuestion = this.questions[this.current];

        const current = this.current;

        if (current === 0) {
            return;
        }

        this.ctrlNext.classList.remove("hide");

        // increment current question iterator
        --this.current;

        // update progress bar
        this._progress();

        // Get the next question
        const nextQuestion = this.questions[this.current];

        if (!this.isFilled) {
            // change the current question number/status

            this._updateQuestionNumber();

            // remove class "current" from current question and add it to the next one
            // current question

            currentQuestion.classList.remove("current");
            nextQuestion.classList.add("current");
        }

        // after animation ends, change current question placeholder
        const self = this;
        const onEndTransitionFn = function() {
            // hide the back button if going to the first input
            if (current === 1) {
                self.ctrlPrevious.classList.remove("show");
            }
            self.currentNum.innerHTML = self.nextQuestionNum.innerHTML;
            self.questionStatus.removeChild(self.nextQuestionNum);

            const nextInput = nextQuestion.querySelector(".input");
            nextInput.classList.remove("invalid");
            nextInput.focus();

            // Post Title and quil editor now live on same page so we highlight the title first

            // Current is equal to quill. Set focus if quil and doesn't have value
            // const quillNext = nextQuestion.querySelector(".js-description");
            // if (quillNext && quillNext.value === "") {
            //     quill.focus();
            // }

            nextQuestion.scrollIntoView({ alignToTop: true, behavior: "smooth" });
        };
        onEndTransitionFn();
    };

    guestPost.prototype._nextQuestion = function() {
        // clear any previous error messages
        this._clearError();

        if (!this._validate()) {
            return false;
        }

        this.ctrlPrevious.classList.add("show");

        // current question
        const currentQuestion = this.questions[this.current];

        // increment current question iterator
        ++this.current;

        // update progress bar
        this._progress();

        // Get the next question
        const nextQuestion = this.questions[this.current];

        if (!this.isFilled) {
            // change the current question number/status
            this._updateQuestionNumber();

            // remove class "current" from current question and add it to the next one
            // current question

            currentQuestion.classList.remove("current");
            nextQuestion.classList.add("current");
        }

        // after animation ends, change current question placeholder
        const self = this;
        const onEndTransitionFn = function() {
            self.currentNum.innerHTML = self.nextQuestionNum.innerHTML;
            self.questionStatus.removeChild(self.nextQuestionNum);
            // force the focus on the next input
            const nextInput = nextQuestion.querySelector(".input");
            nextInput.classList.remove("invalid");
            nextInput.focus();

            nextQuestion.scrollIntoView({ alignToTop: false, behavior: "smooth" });

        };
        onEndTransitionFn();
    };

    // updates the progress bar by setting its width
    guestPost.prototype._progress = function() {
        this.progress.style.width = `${(this.current + 1) * (100 / this.questionsCount)}%`;

        if (this.current + 1 === this.questionsCount) {
            this.ctrlNext.classList.add("hide"); // Hide the next button on the last step
        }
    };

    // changes the current question number
    guestPost.prototype._updateQuestionNumber = function() {
        // first, create next question number placeholder
        this.nextQuestionNum = document.createElement("span");
        this.nextQuestionNum.className = "number-next";
        this.nextQuestionNum.innerHTML = Number(this.current + 1);

        // insert it in the DOM
        this.questionStatus.appendChild(this.nextQuestionNum);
    };

    guestPost.prototype._isQuill = function() {
        if (this.questions[this.current].querySelector(".js-description")) {
            return true;
        }
        return false;
    };

    // TODO (next version..)
    // the validation function
    guestPost.prototype._validate = function() {
        // current question´s input
        const current = this.questions[this.current];
        const nodes = current.querySelectorAll(".input");
        let valid = true;

        for (let i = 0; i < nodes.length; ++i) {
            const currentElem = nodes[i];
            currentElem.classList.remove("invalid");
            let required;
            if (current.querySelector(".required")) {
                required = current.querySelector(".required").classList.contains("required");
            } else {
                required = false;
            }

            let input = currentElem.value;

            // Current is equal to quill
            if (currentElem.classList.contains("js-description")) {
                currentElem.value = quill.root.innerHTML;
                input = quill.getText().trim();
            }

            if (currentElem.classList.contains("js-email") && !this._validateEmail(input)) {
                // Current is equal to the email field
                this._showError("INVALIDEMAIL", currentElem);
                valid = false;
            } else if (currentElem.classList.contains("js-bio") && !this._validateBioLength(currentElem)) {
                // Current is equal to the email field
                this._showError("INVALIDBIO", currentElem);
                valid = false;
            } else if (current.querySelector(".js-recaptcha") && !this._validateRecaptcha()) {
                this._showError("INVALIDCAPTCHA", currentElem);
                valid = false;
            } else if (current.querySelector(".js-recaptcha") && this._validateRecaptcha()) {
                valid = true;
            } else if (input === "" && required) {
                this._showError("EMPTYSTR", currentElem);
                valid = false;
            }

            if (currentElem.classList.contains("invalid")) {
                currentElem.scrollIntoView({ alignToTop: true, behavior: "smooth" });
            }
        }

        return valid;
    };

    guestPost.prototype._validateBioLength = function(bio) {
        const maxLength = Number(bio.getAttribute("maxlength"));
        if (bio.value.length > maxLength) {
            return false;
        }

        return true;
    };

    guestPost.prototype._bioCounter = function(bio) {
        return bio.length; // Length appears to be a zero based count
    };

    guestPost.prototype._bioCounterDisplay = function(elem) {
        const count = this._bioCounter(document.activeElement.value);
        elem.innerText = count;
    };

    guestPost.prototype._validateEmail = function(email) {
        const regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; // eslint-disable-line no-useless-escape

        if (regex.test(email)) {
            return true;
        }

        return false;
    };

    guestPost.prototype._validateRecaptcha = function() {
        /* global grecaptcha */

        const response = grecaptcha.getResponse();

        if (response !== "") {
            this._clearError();
            return true;
        }

        return false;
    };

    // TODO (next version..)
    guestPost.prototype._showError = function(err, node) {
        let message = "";
        switch (err) {
        case "EMPTYSTR":
            message = "Please complete this field";
            break;
        case "INVALIDEMAIL":
            message = "Please use a valid email address";
            break;
        case "INVALIDCAPTCHA":
            message = "Please complete the captcha";
            break;
        case "INVALIDBIO":
            message = "Please keep your bio under 500 characters";
            break;
        }

        node.classList.add("invalid");

        const errMsg = node.parentNode.querySelector(".error-message");
        errMsg.innerHTML = message;
        errMsg.classList.add("show");
    };

    // clears/hides the current error message
    guestPost.prototype._clearError = function() {
        const error = document.querySelectorAll(".error-message");
        for (let i = 0; error.length > i; i++) {
            error[i].classList.remove("show");
        }
    };

    // add to global namespace
    window.guestPost = guestPost;

    const theForm = document.getElementById("guest_post");
    if (theForm) {
        new guestPost(theForm, {});
    }

    const submitBtn = theForm.querySelector(".send-it");

    submitBtn.addEventListener("click", function() {
        theForm.querySelector(".guest-post-inner").classList.add("hide");

        submitGuestPost();
    });

    window.recaptchaCallback = function recaptchaCallback() {
        theForm.isFilled = true;
        theForm.querySelector("button.next").classList.add("hide");
        submitBtn.classList.add("show");
    };
})(window);

$(function() {
    if (document.querySelector("#guest_post")) {
        setupSiteDropdown();

        // Clear the editor default contents on load
        document.querySelector(".ql-editor").innerHTML = "";

        // Setting the hidden input to the value of the WYSIWYG
        const postContent = document.querySelector(".js-description");
        postContent.value = quill.root.innerHTML;

        quill.on("selection-change", function(range, oldRange) {
            if (range === null && oldRange !== null) {
                // blur from the editor
                postContent.value = quill.root.innerHTML;
            }
        });

        // Let's get the editor and set focus if clicked in the content area
        const editorBody = document.querySelector(".js-editor");

        editorBody.addEventListener("click", function() {
            quill.focus();
        });

        const bio = document.querySelector(".js-bio");
        const bioLength = bio.value.length;
        const bioMaxLength = bio.getAttribute("maxlength");

        document.querySelector(".bio-count").innerText = bioLength;
        document.querySelector(".bio-total").innerText = bioMaxLength;
    }
});
